import { post } from '../../../DAL/data-provider';

export const addToCartPopup = async (
    skuId: number
) => {
    return post('/api/shoppingcart/add-to-cart-popup', {
        skuId,
    });
};
